
import React from 'react';
import PropTypes from 'prop-types';
import { ExpansionPanel } from 'react-md';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

const ViewOnlyPanel = ({
  intl, objective, comment, createTime, psyName, userAttributes: { isPsy }, first
}) => (
  <ExpansionPanel
    label={intl.formatDate(createTime, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    })}
    secondaryLabel={psyName}
    footer={null}
    defaultExpanded={first}
  >
    <FormattedMessage id="followUp.objective" tagName="h5" />
    <p>{objective}</p>

    {isPsy &&
      <div>
        <FormattedMessage id="followUp.comment" tagName="h5" />
        <p>{comment}</p>
      </div>
    }

  </ExpansionPanel>
);

ViewOnlyPanel.propTypes = {
  intl: intlShape.isRequired,
  objective: PropTypes.string,
  comment: PropTypes.string,
  createTime: PropTypes.string,
  psyName: PropTypes.string,
  userAttributes: PropTypes.shape({
    isPsy: PropTypes.bool.isRequired,
  }).isRequired,
};

export default injectIntl(ViewOnlyPanel);



// WEBPACK FOOTER //
// ./src/components/FollowUp/ViewOnlyPanel.js